import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const auth = useAuth();
  const authRoles = auth.user?.profile?.role || [];
  const [activeRole, setActiveRole] = useState(null);

  const hasRole = (role) => authRoles.includes(role);  
  const hasAnyRole = (...roles) => roles.some((r) => authRoles.includes(r));

  useEffect(() => {
    if (authRoles.length > 0 && !activeRole) {
      setActiveRole(authRoles[0]);
    }
  }, [authRoles]);
  return(
    <PermissionContext.Provider value={{ authRoles, hasRole, hasAnyRole, activeRole, setActiveRole }}>
        {children}
    </PermissionContext.Provider>
  )

  };

export const usePermissionContext = () => {
  return useContext(PermissionContext);
};
